module.exports = __webpack_public_path__ + "img/hvh-1.f0c7b8d3.jpg";